import { LoadingState } from '../../types';
import { Sample } from '../../../../../../@types/samples/types';

/**
 * Returns true when the Liao parameter limits UI should be disabled.
 *
 * Required fields: sw curve, pc curve, swir, oil_grad, water_grad.
 * Optional fields (qv, salinity, phi_res) are NOT checked here — they get
 * defaults in the worker (0, 140, 1 respectively).
 */
export function computeIsLiaoDisabled(
  sample: Sample | undefined | null,
  loading: LoadingState
): boolean {
  if (!sample) return true;
  if (loading.bestValues || loading.custom) return true;

  const { water_grad: waterGrad, oil_grad: oilGrad, input_sample_curves, input_sample_values } =
    sample;

  const sw = input_sample_curves.pc_model?.sw;
  const pc = input_sample_curves.pc_model?.pc;
  const swir = input_sample_values.swi;

  const dependencies = [sw?.length || null, pc?.length || null, swir, oilGrad, waterGrad];

  return dependencies.some(value => value === null || value === undefined);
}
